var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0007 6.66659C11.0007 9.05982 9.06055 10.9999 6.66732 10.9999C4.27408 10.9999 2.33398 9.05982 2.33398 6.66659C2.33398 4.27335 4.27408 2.33325 6.66732 2.33325C9.06055 2.33325 11.0007 4.27335 11.0007 6.66659ZM10.3818 11.7968C9.33835 12.5537 8.05495 12.9999 6.66732 12.9999C3.16951 12.9999 0.333984 10.1644 0.333984 6.66659C0.333984 3.16878 3.16951 0.333252 6.66732 0.333252C10.1651 0.333252 13.0007 3.16878 13.0007 6.66659C13.0007 8.05497 12.5539 9.33902 11.7963 10.3828C12.5634 11.1617 13.8195 12.4101 14.3708 12.9559L12.9638 14.3773C12.4153 13.8343 11.1603 12.587 10.3818 11.7968Z",
    fill: "#CDD0D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e99f1239708013fccc9949464321a79e.svg";
export { ForwardRef as ReactComponent };